import { useForm, observer } from "@formily/react";
import {
  EnvironmentOutlined,
  MailOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { parsePhoneNumber } from "@rumble-it/common-lib/src/helpers/phoneNumber";
import { IServicePartner } from "@rumble-it/common-lib/src/types/ServicePartner";
import { getConfigValue } from "@rumble-it/common-lib/src/config";
import { Button } from "./Button";

export const ServicePartnerCard = observer(() => {
  const form = useForm();
  const servicePartner = form.values.servicePartner;
  if (!servicePartner) return null;

  const getServicepartnerAddress = (servicePartner: IServicePartner) => {
    const { address, name } = servicePartner;
    if (
      !address ||
      !address.street ||
      !address.streetNumber ||
      !address.postalCode ||
      !address.city
    ) {
      return `https://www.google.com/maps/search/?api=1&query=${name}`;
    }
    return `https://www.google.com/maps/dir/?api=1&destination=${address.street}+${address.streetNumber}+${address.streetNumberAddition || ""},+${address.postalCode}+${address.city}`;
  };

  const getServicepartnerAddressLink = (servicePartner: IServicePartner) =>
    encodeURI(getServicepartnerAddress(servicePartner));

  const streetLine = [
    servicePartner.address?.street,
    servicePartner.address?.streetNumber,
    servicePartner.address?.streetNumberAddition,
  ]
    .filter(Boolean)
    .join(" ");

  const cityLine = [
    servicePartner.address?.postalCode,
    servicePartner.address?.city,
  ]
    .filter(Boolean)
    .join(" ");

  const fullAddressLine = [streetLine, cityLine].filter(Boolean).join(", ");

  let servicePartnerTelephone = null;
  if (servicePartner.telephone) {
    servicePartnerTelephone = parsePhoneNumber({
      phoneNumber: servicePartner.telephone,
    });
  }

  return (
    <>
      <div
        className="bg-no-repeat bg-center bg-cover h-[1px] pb-[20%] rounded-lg"
        style={{
          backgroundImage: `url(${
            servicePartner.headerImage?.contentUrl ||
            `${getConfigValue("cdnUrl")}/static/widget/servicepartner/banner-1600x816.webp`
          })`,
        }}
      />
      <div className="p-1 pt-5 grid grid-cols-1 gap-3">
        <div className="flex items-center">
          <span className="w-7 flex items-center justify-center mr-4">
            <EnvironmentOutlined />
          </span>
          <div>
            <h3 className="leading-6 font-bold">{servicePartner.fullName}</h3>
            <p className="text-gray-500">{fullAddressLine}</p>
          </div>
        </div>

        {servicePartner.telephone && servicePartnerTelephone ? (
          <div className="flex items-center">
            <span className="w-7 flex items-center justify-center mr-4">
              <PhoneOutlined />
            </span>
            <div>
              <a
                className="font-bold leading-6"
                href={servicePartnerTelephone.getURI()}
              >
                {servicePartnerTelephone.formatNational()}
              </a>
            </div>
          </div>
        ) : null}

        {servicePartner.email ? (
          <div className="flex items-center">
            <span className="w-7 flex items-center justify-center mr-4">
              <MailOutlined />
            </span>
            <div>
              <a
                className="font-bold leading-6"
                href={`mailto:${servicePartner.email}`}
              >
                {servicePartner.email}
              </a>
            </div>
          </div>
        ) : null}

        <Button
          type="primary"
          href={getServicepartnerAddressLink(servicePartner)}
          className="w-full mt-5 rumbledirect__my__button"
          target="_blank"
        >
          Routebeschrijving
        </Button>
      </div>
    </>
  );
});
